import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-712c5956"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "error-list"
}
const _hoisted_3 = { class: "text-center mt-16" }
const _hoisted_4 = {
  key: 1,
  class: "wrapper"
}
const _hoisted_5 = {
  key: 0,
  class: "error-list"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Please check the number for typos", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, "Please make sure you enter a valid NPI Number", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_10 = { class: "text-center mt-16" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Skip ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Form, {
          as: "el-form",
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(({ errors }) => [
            _createVNode(_component_app_input, {
              clearable: "",
              modelValue: _ctx.npiValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.npiValue) = $event)),
              name: "npi",
              label: _ctx.$localize('registration.npi.number'),
              placeholder: _ctx.$localize('registration.add.your.npi'),
              controlClass: _ctx.errorNPI ? 'is-error' : ''
            }, null, 8, ["modelValue", "label", "placeholder", "controlClass"]),
            (_ctx.errorNPI)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.$localize('registration.npi.error1')), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.$localize('registration.npi.error2')), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_app_button, {
              onClick: _ctx.nextStep,
              disabled: !_ctx.npiValue || !!errors.npi || _ctx.errorNPI,
              type: "primary",
              "native-type": "submit",
              class: "w-100 el-button-lg",
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.npi.button.next')), 1)
              ]),
              _: 2
            }, 1032, ["onClick", "disabled"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: _ctx.skipNpiUrl,
                class: "router-link dark-color"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('registration.npi.button.skip')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(_component_Form, {
          as: "el-form",
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(({ errors }) => [
            _createVNode(_component_app_input, {
              clearable: "",
              modelValue: _ctx.npiValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.npiValue) = $event)),
              name: "npi",
              label: "NPI Number",
              placeholder: "Add your NPI Number",
              controlClass: _ctx.errorNPI ? 'is-error' : ''
            }, null, 8, ["modelValue", "controlClass"]),
            (_ctx.errorNPI)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_5, _hoisted_8))
              : _createCommentVNode("", true),
            _createVNode(_component_app_button, {
              onClick: _ctx.nextStep,
              disabled: !_ctx.npiValue || !!errors.npi || _ctx.errorNPI,
              type: "primary",
              "native-type": "submit",
              class: "w-100 el-button-lg",
              round: ""
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 2
            }, 1032, ["onClick", "disabled"]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: _ctx.skipNpiUrl,
                class: "router-link dark-color"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ]))
}